module.exports = "<header class=\"header\" id=\"header\">\n  <div class=\"container row middle-xs\">\n    <div class=\"col-xs-6 header--left\">\n      <div class=\"logo\"><a href=\"https://fizy.com\"></a></div>\n    </div>\n    <div class=\"col-xs-6 header--right\">\n      <a class=\"button button--outline button--small button--rounded button--white button--icon-on-right icon-logout\"\n        ng-click=\"$ctrl.onLogin()\">\n        <span translate>header.menu.login</span></a>\n    </div>\n  </div>\n</header>";


//////////////////
// WEBPACK FOOTER
// ./src/app/no-auth/components/header/header.html
// module id = 446
// module chunks = 0